export default "/048cb1f2b29308e18768c65cfd51e426596a830c/48c3d350a874654b9919fc00f7ab5f35.png";